import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ReplicaCard from '../../../components/Card/Database/ReplicaCard';
import { Database, AlertCircle } from 'lucide-react';

const Replicas = ({ databaseInfo }) => {
  const { projectId, databaseId } = useParams();
  const [replicas, setReplicas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const databaseIdentifier = databaseInfo?.databaseName;

  useEffect(() => {
    const fetchReplicas = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://cloudify-prod.wizr.in/rds/instances/${databaseIdentifier}/replicas`);
        setReplicas(response.data.replicas);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch replicas:', err);
        setError('Failed to fetch read replicas. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchReplicas();
  }, [databaseId, databaseIdentifier]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center">
          <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
          <span className="text-red-700">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div className="flex justify-between items-center mb-5 border-b border-gray-100 pb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Read Replicas</h2>
            <p className="text-gray-500 text-sm mt-1">Manage your database read replicas for improved performance</p>
          </div>
        </div>

        {replicas.length === 0 ? (
          <div className="py-12 text-center bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <Database className="w-12 h-12 text-gray-400 mx-auto mb-3" />
            <h3 className="text-lg font-medium text-gray-600 mb-1">No Read Replicas</h3>
            <p className="text-gray-500 max-w-md mx-auto">
              This database instance doesn't have any read replicas. Read replicas can help distribute read traffic and improve performance.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {replicas.map((replica) => (
              <ReplicaCard 
                key={replica.DBInstanceIdentifier} 
                replica={replica}
                projectId={projectId}
                databaseId={databaseId}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Replicas;